<div *ngIf="!!packageList"
     class="full-height layout-row"
     [ngbTooltip]="tooltip"
     openDelay="300">

  <bringoz-icon iconName="spot" fill="#A3A3A3"></bringoz-icon>
  <span class="md-tiny">{{packageList | packageSpots}}</span>

  <ng-template #tooltip>
    <span>{{spotsSum === 1 ? 'X_SPOT' : 'X_SPOTS' | translate:{sum: spotsSum} }}</span>
  </ng-template>

</div>
